export const TABLE_NEXT_LEADING_VISUAL_AUTOSIZE_EXTRA_WIDTH = 88;
